import { MODULES } from '../constants/modules';

// The iOS app's public details, shared by the nav button and the /ios-app page.

// Set this to the App Store listing's URL once the app is released. Until
// then the page shows "Coming soon to the App Store" instead of a download
// link, since there is nothing to link to yet.
export const IOS_APP_STORE_URL = null;

export const IOS_APP_PATH = '/ios-app';

// The /ios-app page stays hidden until the app is ready: the route redirects
// home, the header leaves out its "Get the app" links and the page is kept
// out of the sitemap. To publish it, set this to true and add /ios-app back
// to src/data/publicRouteManifest.json.
export const IOS_APP_PAGE_LIVE = false;

// IPHONEOS_DEPLOYMENT_TARGET in ios/CBATAcademy.xcodeproj.
export const IOS_MINIMUM_VERSION = '17';

// The app covers the military track, minus the modules that need a mouse,
// keyboard or joystick -- the same ones the website flags as unusable on a
// phone. iosApp.test.js checks this against ModuleCatalog.portedIDs in
// ios/CBATKit, so the page never advertises a module the app doesn't have.
export const IOS_APP_MODULES = MODULES.filter(
  (module) => module.preparationFamily !== 'commercial' && !module.mobileIncompatible
);
